// from JSP?
/* global fundedByTarget */

/* TODO:  get a list of donorids and make sure all target icons have the word target in them */


$(document).ready(function () {
    function isTargetFundedProject() {
        if (fundedByTarget) {
            return true;
        }
        if ($('.match-offer').length > 0) {
            const imgSrc = $('.match-offer .logo-holder img').attr('src');
            if (imgSrc && imgSrc.indexOf('target') > -1) {
                return true;
            }
        }
        if ($('.partner-logo-wrapper').length > 0) {
            const partnerCount = $('.partner-logo-wrapper').length;
            for (let i = 0; i < partnerCount; i++) {
                const imgSrc = $('.partner-logo-wrapper').eq(i).find('.logo-holder img').css('background-image');
                if (imgSrc && imgSrc.indexOf('target') > -1) {
                    return true;
                }
            }
        }
        return false;
    }

    if (isTargetFundedProject()) {
        $('.vendor').hide();
    }
});
